import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Footer, Button } from '@3plearning/react-components';
import {
    REPORT_LEVELS,
    REPORT_LEVEL_ALL_YEARS
} from '../sub-heading/export-report/export-report-actions';
import {
    ACTIVITY_MASTERY,
    PARTICIPATION,
    LIVE_MATHS,
    SKILL_QUESTS_MASTERY
} from '../report-filters/filter-constants';
import activeFiltersSelectors from '../report-filters/redux/active-filters/active-filters-selectors';
import reportStateActions, {
    REPORT_STATE_ALL_YEARS,
    REPORT_STATE_ALL_CLASSES,
    REPORT_STATE_TOP_TEN
} from '../../containers/participation/all-classes/report-state/report-state-actions';
import allClassesActions from '../../containers/participation/all-classes/all-classes-actions';
import { dateFilterPropType } from '../report-filters/filter-prop-types';

/**
 * Displays Footer component for Participation All Years report
 * NOTE: Discovered this footer is not visible in any scenario. The Container pushes it out of view
 * but all functionality still works fine.
 */
export class ParticipationFooter extends PureComponent {
    static propTypes = {
        className: PropTypes.string,
        reportLevel: PropTypes.oneOf(REPORT_LEVELS).isRequired,
        reportType: PropTypes.oneOf([
            ACTIVITY_MASTERY,
            PARTICIPATION,
            LIVE_MATHS,
            SKILL_QUESTS_MASTERY
        ]).isRequired,
        reportState: PropTypes.oneOf([
            REPORT_STATE_ALL_YEARS,
            REPORT_STATE_ALL_CLASSES,
            REPORT_STATE_TOP_TEN
        ]).isRequired,
        selectedDate: dateFilterPropType,
        setReportState: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        const { reportLevel, reportType } = props;

        this.i18n = window.i18n;

        this.state = {
            display: this.shouldDisplayFooter(reportLevel, reportType)
        };
    }

    componentWillReceiveProps(newProps) {
        const { reportLevel, reportType } = this.props;
        const {
            reportLevel: newReportLevel,
            reportType: newReportType
        } = newProps;
        if (reportLevel !== newReportLevel || reportType !== newReportType) {
            this.setState({
                display: this.shouldDisplayFooter(newReportLevel, newReportType)
            });
        }
    }

    shouldDisplayFooter = (reportLevel, reportType) =>
        reportLevel === REPORT_LEVEL_ALL_YEARS && reportType === PARTICIPATION;

    loadByYear = () => {
        this.loadReport('getAllYearsData', REPORT_STATE_ALL_YEARS);
    };

    loadByClass = () => {
        this.loadReport('getByClassData', REPORT_STATE_ALL_CLASSES);
    };

    loadTopTen = () => {
        this.loadReport('getTop10StudentsData', REPORT_STATE_TOP_TEN);
    };

    loadReport(actionCreator, reportState) {
        const { selectedDate, setReportState } = this.props;
        setReportState(reportState);
        this.props[actionCreator](selectedDate);
    }

    render() {
        const { className, reportState } = this.props;
        this.i18n = window.i18n;
        const { display } = this.state;
        if (!display || !this.i18n) {
            return null;
        }
        const byYear = this.i18n._('Button Label - ByYear');
        const byClass = this.i18n._('Button Label - ByClass');
        const topTwenty = this.i18n._('Button Label - TopTwentyStudents');
        return (
            <Footer className={className}>
                <Button
                    text={byYear}
                    primary
                    type={Button.LOZENGE}
                    disabled={reportState === REPORT_STATE_ALL_YEARS}
                    onClick={this.loadByYear}
                />
                <Button
                    text={byClass}
                    primary
                    type={Button.LOZENGE}
                    disabled={reportState === REPORT_STATE_ALL_CLASSES}
                    onClick={this.loadByClass}
                />
                <Button
                    text={topTwenty}
                    primary
                    type={Button.LOZENGE}
                    disabled={reportState === REPORT_STATE_TOP_TEN}
                    onClick={this.loadTopTen}
                />
            </Footer>
        );
    }
}

/*
 * mapStateToProps - set component props using redux state
 */
function mapStateToProps(state) {
    return {
        reportLevel: activeFiltersSelectors.selectReportLevel(state),
        reportType: activeFiltersSelectors.selectReportId(state),
        reportState: state.reportState,
        selectedDate: activeFiltersSelectors.selectDate(state)
    };
}

/*
 * mapDispatchToProps - set component props, wrapping redux action creators in a dispatch call
 */
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            getAllYearsData: allClassesActions.getParticipationData,
            getByClassData: allClassesActions.getByClassData,
            getTop10StudentsData: allClassesActions.getTop10StudentsData,
            setReportState: reportStateActions.setReportState
        },
        dispatch
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ParticipationFooter);



// WEBPACK FOOTER //
// ./components/participation-footer/participation-footer.js